import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "../utils/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/",
    redirect: "/dashboard"
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/users",
    name: "users",
    component: () => import("../views/UserManagement.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/members",
    name: "members",
    component: () => import("../views/MemberManagement.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/distribution",
    name: "distribution",
    component: () => import("../views/DistributionManagement.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/bans",
    name: "bans",
    component: () => import("../views/BanManagement.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/blacklist",
    redirect: "/bans"
  },
  {
    path: "/topups",
    name: "topups",
    component: () => import("../views/TopupRecords.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/anomalies",
    name: "anomalies",
    component: () => import("../views/AnomalyManagement.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/analysis",
    name: "analysis",
    component: () => import("../views/DataAnalysis.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/security-ips",
    name: "security-ips",
    component: () => import("../views/SecurityIPs.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "hash",
  routes
});

router.beforeEach((to, _from, next) => {
  const token = getToken();
  if (to.meta.requiresAuth && !token) {
    next({ name: "login" });
    return;
  }
  if (to.name === "login" && token) {
    next({ name: "dashboard" });
    return;
  }
  next();
});

export default router;
